import { io, Socket } from "socket.io-client";

class SocketService {
  private sockets: Map<string, Socket> = new Map();
  public connect(userId: string, dispatch: any): Socket {
    // Return existing socket if already connected
    if (this.sockets.has(userId)) {
      const existingSocket = this.sockets.get(userId)!;
      // Ensure it's connected
      if (!existingSocket.connected) {
        console.log("SocketService: Reconnecting existing socket for", userId);
        existingSocket.connect();
      }
      return existingSocket;
    }

    // Create new socket connection
    console.log("SocketService: Creating new socket for", userId, "URL:", process.env.REACT_APP_URL);

    const socket = io(process.env.REACT_APP_URL || "", {
      withCredentials: true, // Send cookies with request
      autoConnect: true,
      transports: ['websocket', 'polling'],
      extraHeaders: {
        // Cookies will be sent automatically with withCredentials: true
      }
    });

    socket.on("connect", () => {
      console.log("SocketService: Socket connected for user", userId);
    });

    socket.on("connect_error", (error) => {
      console.error("SocketService: Connection error for user", userId, error);
    });

    socket.on("disconnect", (reason) => {
      console.log("SocketService: Socket disconnected for user", userId, "reason:", reason);
    });

    // socket.on("notification", (message) => {
    //   console.log(`Received notification for user ${userId}:`, message);
    //   dispatch(addMessage());
    // });

    this.sockets.set(userId, socket);
    return socket;
  }

  public disconnect(userId: string): void {
    const socket = this.sockets.get(userId);
    if (socket) {
      socket.disconnect(); // Disconnect the socket
      this.sockets.delete(userId); // Remove it from the map
    }
  }
  public getSocket(userId: string): Socket | undefined {
    return this.sockets.get(userId);
  }
  // Check if a socket is connected
  public isConnected(userId: string): boolean {
    const socket = this.sockets.get(userId);
    return socket ? socket.connected : false;
  }
}

const socketService = new SocketService();
export default socketService;
